import React, { useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";

const ClientTable = ({ toByYear, finalYear }) => {
  const { SearchBar } = Search;
  const [row, setRow] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  const columns = [
    {
      dataField: "client.title",
      text: "Société",
      headerAlign: "center",
    },
    {
      dataField: "details.ca",
      text: "Chiffre d'affaires",
      align: "center",
      headerAlign: "center",
      headerStyle: { width: "25%" },
    },
    {
      dataField: "details.none",
      text: "Les échéances",
      align: "center",
      headerAlign: "center",
      headerStyle: { width: "25%" },
    },
    {
      dataField: "details.impayed",
      text: "Les impayés",
      align: "center",
      headerAlign: "center",
      headerStyle: { width: "25%" },
    },
  ];

  const MyExportCSV = (props) => {
    const handleExport = () => props.onExport();
    return (
      <button className="btn btn-dark" onClick={handleExport}>
        Télécharger CSV
      </button>
    );
  };

  const options = {
    sizePerPage: 10, // Default number of items per page
    sizePerPageList: [5, 10, 20], // Options for number of items per page
  };


  if (!toByYear || toByYear.length === 0) {
    return <></>;
  }

  return (
    <div className="card content mx-3">
      <div className="card-header">
        <h3 className="card-title">Clients de l'année : {finalYear}</h3>
      </div>
      <div className="card-body">
        <ToolkitProvider
          keyField="client.id"
          data={toByYear}
          columns={columns}
          exportCSV
          search
        >
          {(props) => (
            <div>
            
              <div className="row ml-0">
                <div>
                  <SearchBar
                    {...props.searchProps}
                    className="custome-search-field"
                    placeholder="Chercher"
                  />
                </div>
                <div className="ml-auto mr-0">
                  <MyExportCSV {...props.csvProps}></MyExportCSV>
                </div>
              </div>
              <BootstrapTable
                {...props.baseProps}
                pagination={paginationFactory(options)}
                striped
                hover
                condensed
              />
            </div>
          )}
        </ToolkitProvider>
      </div>
    </div>
  );
};

export default ClientTable;
